import React, { useState } from 'react';
import Navbar from './Navbar';
import { Button, Dialog, DialogTitle, Grid2, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { Form } from 'react-bootstrap';
import toast from 'react-hot-toast';

export default function Catalogs() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [fetchCatalogsData, setFetchCatalogsData] = React.useState([]);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);

  function handleClose(){
    setOpen(false);
  }
  function handleClose2(){
    setEdit(false);
  }

  // Fetch the catalog list data
  const fetchCatalogsLists = () => {
    const token = localStorage.getItem('accessToken');
    fetch(`https://api.adoop.in/api/v2/catalogs`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setFetchCatalogsData(data);  // Update the state with the fetched data
      })
      .catch((error) => console.error(error));
  };

  // Call the function to fetch data on component mount
  React.useEffect(() => {
    fetchCatalogsLists();
  }, []);

  // Handle page change
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0); // Reset page to the first page when rows per page changes
  };

  // Slice the data for the current page
  const currentData = fetchCatalogsData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  function add(){
    setOpen(true);
  }
  const [formData,setFormData] = useState({
    name:"",
    description:"",
    image:""
  })

 
  const getBase64Path = (e) => {
    const token = localStorage.getItem('accessToken');
    const image = e.target.files[0];
    let reader = new FileReader();
  
    reader.onload = () => {
      // Prepare FormData with base64 image data
      const formData = new FormData();
      formData.append('file', image); 
      fetch(`https://api.adoop.in/api/v2/adoop/upload_image`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
     
        },
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        console.log('Response:', data);
  
        setFormData(prevState => ({
          ...prevState,
          image: data.id 
        }));
      })
      .catch(error => {
        console.error('Error uploading file:', error);
      });
    };
  
    reader.readAsDataURL(image);
  };
  
  
   
  const addCatalogs = () => {
    const token = localStorage.getItem('accessToken');
    fetch(`https://api.adoop.in/api/v2/catalogs`, {
      method: "POST",
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Response from server:', data);
      toast.success(data.message)
      setFormData({
        name: '',
    description: '',
    image:''
      })
      setOpen(false);
      toast.success("Catalog Added Successfully");
      fetchCatalogsLists();
    })
    .catch(error => console.error(error));
  };

  function editCatalog(id){
    console.log(id);
    setEdit(true);
    setInputValues({
        id: id.id || "",
        name: id.name || "",  // Assign the name from the id object, or an empty string if it's undefined
        description: id.description || "",
        image: id.image || "",  // Similarly for description
    });
  }

  const [inputValues,setInputValues] = useState({
    name:"",
    description:"",
    image:""
  })

  function deleteCatalog(id) {
    const token = localStorage.getItem('accessToken');
    // Show a confirmation dialog before proceeding
    const isConfirmed = window.confirm('Are you sure you want to delete this catalog?');
    
    if (isConfirmed) {
        // Proceed with the DELETE request if the user confirms
        fetch(`https://api.adoop.in/api/v2/catalogs/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        })
        .then((response) => response.json())
        .then((data) => {
            console.log(data);
            toast.success("Catalog Deleted Successfully");
            fetchCatalogsLists();  // Update the state with the fetched data
        })
        .catch((error) => console.error('Error:', error));
    } else {
        // If the user cancels, log that the delete was cancelled
        console.log('Delete operation cancelled.');
    }
}

function updateCatalogs(id){
  const token = localStorage.getItem('accessToken');
    fetch(`https://api.adoop.in/api/v2/catalogs/${id}`, {
        method: "PUT",
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(inputValues)
      })
      .then(response => response.json())
      .then(data => {
        console.log('Response from server:', data);
        toast.success(data.message)
        setInputValues({
          name: '',
      description: '',
        })
        setOpen(false);
        toast.success("Catalog Updated Successfully");
        fetchCatalogsLists();
        setEdit(false);
      })
      .catch(error => console.error(error));
}


const handleFileChange = (e) => {
    // If the user selects a file, update the `image` in the state
    const file = e.target.files[0];
    if (file) {
      // For example, storing the file name or a file URL
      setInputValues((prevValues) => ({
        ...prevValues,
        image: file.name, // or you can handle file upload separately
      }));
    }
  };



  return (
    <div>
      <Navbar />
      <br />
      <Grid2 container style={{display:"flex", justifyContent:"space-between"}}>
      <Typography variant="h4" gutterBottom style={{marginLeft:"20px"}}>
        Catalogs_List
      </Typography>
      <Button variant='contained' style={{marginRight:"20px", backgroundColor:"gold", color:"black"}} onClick={add}>Add</Button>
      </Grid2>
      <br />
      <Grid2 container>
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          <TableContainer sx={{ maxHeight: 940 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell align='center'>Sr. No.</TableCell>
                  <TableCell align='center'>Name</TableCell>
                  <TableCell align='center'>Description</TableCell>
                  <TableCell align='center'>Image</TableCell>
                  <TableCell align='center'>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentData.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell align='center'>{page * rowsPerPage + index + 1}</TableCell> {/* Adjust index based on the page */}
                    <TableCell align='center'>{data.name}</TableCell>
                    <TableCell align='center'>{data.description}</TableCell> {/* Assuming 'address' field exists */}
                    {/* `https://d3p6cw3ny59ckg.cloudfront.net/test/` + */}
                    <TableCell align='center'><img src={'https://d3p6cw3ny59ckg.cloudfront.net/store/' +data.image} alt='' width={24} height={24}/></TableCell>
                    <TableCell align='center'>
                        <Button style={{color:"gold"}} onClick={()=>editCatalog(data)}><Edit/></Button>
                        <Button color='error' onClick={()=>deleteCatalog(data.id)}><Delete/></Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={fetchCatalogsData.length}  
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Grid2>

{/* add form */}
      {open?(<>
        <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Add Catalogs</DialogTitle>
      <Grid2 style={{margin:"10px"}}>
      <Form>
      
      <Form.Group>
      <Form.Label>Catalog Name</Form.Label>
      <Form.Control style={{marginLeft:"55px", padding:"10px"}}
      placeholder='Enter Catalog Name'
        type="text"
        name="name"
        value={formData.name}
        onChange={(e) =>setFormData({...formData,name:e.target.value})}
      />
    </Form.Group>
      <br/>
      <Form.Group>
      <Form.Label>Catalog Description</Form.Label>
      <Form.Control style={{marginLeft:"20px", padding:"10px"}}
      placeholder='Enter Catalog Description'
        type="text"
        name="name"
        value={formData.description}
          onChange={(e) =>setFormData({...formData,description:e.target.value})}
       />
    </Form.Group>
   <br/>

   <Form.Group>
      <Form.Label>Catalog Image</Form.Label>
      <Form.Control style={{marginLeft:"47px", padding:"10px"}}
        type="file"
        name="image"
        // value={formData.image}
          // onChange={(e) =>setFormData({...formData,image:e.target.value})}
          onChange={(e) =>getBase64Path(e)}
       />
    </Form.Group>
  
      
     
  
     
      <br/>
     
      <Button variant="contained" style={{backgroundColor:"gold", color:"black", float:"right"}} onClick={addCatalogs}> 
      Submit
      </Button> 
    
    </Form> 
              </Grid2>
    </Dialog>
      </>):("")}

      {/* edit form */}
      {edit && inputValues?(<>
        <Dialog open={edit} onClose={handleClose2}>
      <DialogTitle>Edit Catalogs</DialogTitle>
      <Grid2 style={{margin:"10px"}}>
      <Form>
      
      <Form.Group>
      <Form.Label>Catalog Name</Form.Label>
      <Form.Control style={{marginLeft:"55px", padding:"10px"}}
      placeholder='Enter Catalog Name'
        type="text"
        name="name"
        value={inputValues.name}
        onChange={(e) =>setInputValues({...inputValues,name:e.target.value})}
      />
    </Form.Group>
      <br/>
      <Form.Group>
      <Form.Label>Catalog Description</Form.Label>
      <Form.Control style={{marginLeft:"20px", padding:"10px"}}
      placeholder='Enter Catalog Description'
        type="text"
        name="name"
        value={inputValues.description}
          onChange={(e) =>setInputValues({...inputValues,description:e.target.value})}
       />
    </Form.Group>
   <br/>
  

   <Form.Group>
      <Form.Label>Catalog Image</Form.Label>
      <Form.Control style={{marginLeft:"47px", padding:"10px"}}
        type="file"
        name="image"
        onChange={handleFileChange}
       />
    </Form.Group>
  
      
     
  
     
      <br/>
      <Form.Group>
      <Form.Label>Catalog Image Preview</Form.Label>
      <img src={inputValues.image} alt='' width={100} height={100} style={{marginLeft:"20px"}}/>
    </Form.Group>
     
      <Button variant="contained" style={{backgroundColor:"gold", color:"black", float:"right"}} onClick={()=>updateCatalogs(inputValues.id)}> 
      Update
      </Button> 
    
    </Form> 
              </Grid2>
    </Dialog>
      </>):("")}
    </div>
  );
}
